module.exports = {
    mainImage: 1,
    secondaryImage: 2,
    mainImageMobile: 3,
    coverImage: 4,
}